export const themes = {
  dark: {
    bg: "#000000",
    text: "#f2eee7",
    muted: "#b8afa2",
    dim: "#6f6558",
    border: "#1a120b",
    borderLight: "#100b07",
    surface: "#070707",
    surface2: "#0d0a07",
    link: "#f59e0b",
    linkHover: "#ffbd4a",
    rowHover: "rgba(245, 158, 11, 0.08)",
    selectionBg: "rgba(245, 158, 11, 0.28)",
    shadow: "0 14px 36px rgba(0, 0, 0, 0.24)",
  },
  light: {
    bg: "#fffaf2",
    text: "#1b1712",
    muted: "#51483d",
    dim: "#8b7f70",
    border: "#eadbc6",
    borderLight: "#f3e8d8",
    surface: "#ffffff",
    surface2: "#fff1dc",
    link: "#c26a00",
    linkHover: "#8f4f00",
    rowHover: "rgba(194, 106, 0, 0.07)",
    selectionBg: "rgba(194, 106, 0, 0.18)",
    shadow: "0 12px 30px rgba(27, 23, 18, 0.08)",
  },
};
